module.exports = __webpack_public_path__ + "static/media/Citadel.a26ce36a.png";